import { useMutation } from 'react-query';
import { useZoneContext } from '../../../contexts/useZoneContext';

export const useObtainEntityLeaseMutation = (onError?: (errorMessage: string) => void) => {
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (dto: {
            entityTypeId: number;
            entityGuid?: string;
            durationInMs: number;
        }) => {
            const response = await zoneApiClient.obtainEntityLease(
                dto.entityTypeId,
                dto.entityGuid!,
                dto.durationInMs
            );

            if (!response?.httpResponse.ok) {
                if (response.errorMessage && response.httpResponse.status == 400) {
                    if (response.errors !== undefined && response.errors[0] !== undefined) {
                        throw new Error(
                            `Failed to obtain an entity lease : ${response.errors[0].message}`
                        );
                    }
                }
                throw new Error('Failed to obtain an entity lease');
            }
            return response.payload;
        },
        onError(error) {
            if (error instanceof Error && typeof onError === 'function') {
                onError(error.message);
            }
        },
    });
}
    